__turbopack_context__.v({
  "className": "F5wQCq_className",
  "variable": "F5wQCq_variable",
});
